import { render, staticRenderFns } from "./templatePromo.vue?vue&type=template&id=7560c158&scoped=true"
import script from "./templatePromo.vue?vue&type=script&lang=js"
export * from "./templatePromo.vue?vue&type=script&lang=js"
import style0 from "./templatePromo.vue?vue&type=style&index=0&id=7560c158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560c158",
  null
  
)

export default component.exports